import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SuspensCategoriesService {


  url = environment.serverAPI5 + "/api/suspensecategories";

  constructor(private http: HttpClient) { }

  getAllSuspense(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllSuspenseDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getSuspenseById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditSuspense(Suspense: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, Suspense);
  }

  suspenseCategoriesSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  deleteBySuspenseCategoriesId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }
  downloadSuspensCategoriesTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }
  downloadSuspenseCategoryReport(Page: number, size: number, sort, selectionSuspenseCategories): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
      &size=${size}&sort=${sort}`, selectionSuspenseCategories, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }
}
